module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }